// extracted by mini-css-extract-plugin
export var iconContainer = "Topic-module--icon-container--b1d8c";
export var iconWrapper = "Topic-module--iconWrapper--c4f2b";
export var topicButton = "Topic-module--topic-button--e8262";
export var topicCard = "Topic-module--topic-card--67e5c";
export var topicCategoryLinkWrapper = "Topic-module--topic-category-link-wrapper--3bbda";
export var topicSection = "Topic-module--topic-section--c6fd8";
export var topicSectionButtons = "Topic-module--topic-section-buttons--b0d06";
export var topicSectionHeader = "Topic-module--topic-section-header--c43e6";